import { loadSettings, removeSettings, saveSettings } from "@/utils/browser";
import api from "@/common/api";

const token = loadSettings("token");
const initialState = {
    user: null,
    status: {
        loggedIn: !!token
    },
    token
};

const updateDocument = (theme) => {
    if (theme === "dark") {
        document.getElementById("app").setAttribute("data-bs-theme", theme);
    } else {
        document.getElementById("app").removeAttribute("data-bs-theme");
    }
};

if (initialState.token) {
    api.setToken(initialState.token);
}

export const theme = {
    namespaced: true,
    state() {
        const theme = loadSettings("theme");
        updateDocument(theme);
        return {
            theme
        };
    },
    actions: {
        set({ commit }, params) {
            commit("set", params.theme);
        }
    },
    mutations: {
        set(state, theme) {
            updateDocument(theme);
            state.theme = theme;
            saveSettings("theme", theme);
        }
    }
};

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        login({ commit }, params) {
            return api.login(params.email).then(result => {
                return Promise.resolve(result);
            }).catch(e => {
                commit("loginFailure");
                return Promise.reject(e);
            });
        },
        signup({ commit }, params) {
            return api.signup(params.name, params.email, params.privacy, params.token).then(result => {
                return Promise.resolve(result);
            }).catch(e => {
                commit("loginFailure");
                return Promise.reject(e);
            });
        },
        code({ commit }, params) {
            return api.code(params.email, params.code).then(result => {
                commit("loginSuccess", result);
                return Promise.resolve(result);
            }).catch(e => {
                commit("loginFailure");
                return Promise.reject(e);
            });
        },
        info({ commit }) {
            return api.info().then(result => {
                commit("infoSuccess", result);
                return Promise.resolve(result);
            }).catch(e => {
                return Promise.reject(e);
            });
        },
        update({ commit }, params) {
            return api.update(params).then(result => {
                return Promise.resolve(result);
            }).catch(e => {
                return Promise.reject(e);
            });
        },
        delete({ commit }) {
            return api.delete().then(result => {
                commit("logout");
                return Promise.resolve(result);
            }).catch(e => {
                return Promise.reject(e);
            });
        },
        logout({ commit }) {
            commit("logout");
            return Promise.resolve();
        },
        tokenError({ commit }) {
            commit("logout");
            return Promise.resolve();
        }
    },
    mutations: {
        loginSuccess(state, data) {
            state.status.loggedIn = true;
            api.setToken(data.token);
            saveSettings("token", data.token, !data.remember);
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;

            api.setToken(null);
            removeSettings("token");
        },
        infoSuccess(state, user) {
            state.user = user;
        },
        logout(state) {
            state.status.loggedIn = false;
            state.user = null;

            api.setToken(null);
            removeSettings("token");
        }
    }
};

export const credit = {
    namespaced: true,
    state: {
        duration: 0,
        amount: 0,
        remaining: 0
    },
    actions: {
        update({ commit }, params) {
            return api.avatarsCredits().then(result => {
                commit("set", result);
                return Promise.resolve(result);
            }).catch(e => {
                return Promise.reject(e);
            });
        }
    },
    mutations: {
        set(state, credit) {
            state.amount = credit.amount;
            state.duration = credit.duration;
            state.remaining = credit.remaining;
        }
    }
};
